import {
    Component,
    ViewChildren,
    QueryList,
    ElementRef,
    EventEmitter,
    Output
} from '@angular/core';
import {
    FormArray,
    FormBuilder,
    FormControl,
    ReactiveFormsModule,
    Validators
} from '@angular/forms';
import {CommonModule} from '@angular/common';

@Component({
    selector: 'app-code-input',
    standalone: true,
    imports: [CommonModule, ReactiveFormsModule],
    templateUrl: './code-input.component.html',
    styleUrl: './code-input.component.scss'
})
export class CodeInputComponent {
    @Output() codeCompleted = new EventEmitter<string>();

    @ViewChildren('pinInput') pinInputs!: QueryList<ElementRef>;

    pinForm = this.fb.group({
        pin: this.fb.array([
            new FormControl('', [Validators.required, Validators.maxLength(1), Validators.pattern(/[0-9*]/)]),
            new FormControl('', [Validators.required, Validators.maxLength(1), Validators.pattern(/[0-9*]/)]),
            new FormControl('', [Validators.required, Validators.maxLength(1), Validators.pattern(/[0-9*]/)]),
            new FormControl('', [Validators.required, Validators.maxLength(1), Validators.pattern(/[0-9*]/)]),
        ]),
    });

    get pinControls() {
        return this.pinForm.get('pin') as FormArray;
    }

    constructor(
        private fb: FormBuilder
    ) {
    }

    onInput(event: Event, index: number): void {
        const inputElement = event.target as HTMLInputElement;
        const value = inputElement.value;

        if (!/[0-9*]/.test(value)) {
            inputElement.value = '';
        }

        if (value.length > 1) {
            this.pinControls.at(index).setValue(value.charAt(0));
        }

        if (this.pinControls.at(index).valid && index < this.pinControls.length - 1) {
            this.focusNext(index);
        } else {
            if (this.pinForm.valid) {
                inputElement.blur();
                const pinValue = this.pinControls.controls.map(control => control.value).join('');
                this.codeCompleted.emit(pinValue);
            }
        }
    }

    onKeyDown(event: KeyboardEvent, index: number): void {
        if (event.key === 'Backspace' || event.key === 'Delete') {
            const inputElement = event.target as HTMLInputElement;

            if (inputElement.value.length === 0 && index > 0) {
                event.preventDefault();
                this.focusPrev(index);
            }
        }
    }

    focusNext(currentIndex: number): void {
        const nextIndex = currentIndex + 1;
        const nextInput = this.pinInputs.get(nextIndex)?.nativeElement;
        if (nextInput) {
            nextInput.value = '';
            nextInput.focus();
        }
    }

    focusPrev(currentIndex: number): void {
        const prevIndex = currentIndex - 1;
        const prevInput = this.pinInputs.get(prevIndex)?.nativeElement;
        if (prevInput) {
            prevInput.focus();
            prevInput.value = '';
        }
    }
}

